import { inject, injectable } from "tsyringe";
import { RequestOptions } from "src/infra/http/types";
import type { Transaction } from "src/containers/crm/types";
import { HttpClient } from "src/infra/http/client";
import { autoBind } from "src/shared/decorators/autobind";
import { Environment } from "src/libs/environment";

@injectable()
export class CrmRepository {
    constructor(@inject("HttpClient") private http: HttpClient) {}

    static get userIdentity(): string {
        return window.userIdentity;
    }

    @autoBind
    saveTransaction(data: Transaction) {
        const isFlutter = document.cookie.includes("hide_bottombar");
        const endpoint = CrmRepository.getSaveTransactionUrl();
        const options: RequestOptions = {
            isPublicRequest: false,
            host: Environment.string("APIMGMT_URL"),
            customHeader: {
                ...this.http.httpUtils.getBaseHeaders(),
                ...this.http.httpUtils.getMsBaseHeaders(
                    CrmRepository.userIdentity,
                    "MEP"
                ),
                "x-device-type": isFlutter ? "APP" : "WEB",
            },
            data,
        };
        return this.http.post<void>(endpoint, options);
    }

    private static getSaveTransactionUrl() {
        return "ux-gestion-de-incidentes-crm-pga/mep/servicio-al-cliente/v1/api/insureds/me/trackings";
    }
}
